export enum MegaMenuAction {
  INSTALL_AGENT = 'install-agent',
  RECONFIGURE_AGENT = 'reconfigure-agent',
  MALWARE_SCAN = 'malware-scan',
  IOC_SCAN = 'ioc-scan',
  EXCHANGE_SCAN = 'exchange-scan',
  PATCH_SCAN = 'patch-scan',
  INSTALL_PATCHES = 'install-patches',
  REPAIR_AGENT = 'repair-agent',
  UNINSTALL_AGENT = 'uninstall-agent',
  MARK_GOLDEN_IMAGE = 'mark-golden-image',
  UNMARK_GOLDEN_IMAGE = 'unmark-golden-image',
  SUSPEND_INTEGRITY_MONITORING = 'suspend-integrity-monitoring',
  ASSIGN_POLICY = 'assign-policy',
  //UNINSTALL_AGENT = 'uninstall-agent',
  //RECOVERY_MANAGER = 'recovery-manager',
  ISOLATE_ENDPOINT = 'isolate-endpoint',
  REMOVE_FROM_ISOLATION = 'remove-from-isolation',
  RESTART_TASK = 'restart-task',
  UPDATE_AGENT = 'update-agent',
  ASSIGN_TAGS = 'assign-tags',
  UNASSIGN_TAGS = 'unassign-tags',
  RESUME_INTEGRITY_MONITORING = 'resume-integrity-monitoring',
  RUN_NETWORK_DISCOVERY = 'run-network-discovery',
  RISK_SCAN = 'risk-scan',
  UPDATE_SECURITY_SERVER = 'update-security-server',
  REMOTE_SHELL = 'remote-shell',
  MOVE_TO = 'move-to',
  ASSIGN_SECURITY_SERVERS = 'assign-security-servers',
  SUBMIT_TO_SANDBOX = 'submit-to-sandbox',
  SET_AD_INTEGRATOR = 'set-ad-integrator',
  REMOVE_AD_INTEGRATOR = 'remove-ad-integrator',
  REMOVE_AD_INTEGRATION = 'remove-ad-integration',
  SUSPEND_PROTECTION = 'suspend-protection',
  RESUME_PROTECTION = 'resume-protection',
  ASSIGN_VCENTER_INTEGRATOR = 'assign-vcenter-integrator',
  UNASSIGN_VCENTER_INTEGRATOR = 'unassign-vcenter-integrator',
  SYNC_WITH_EC2 = 'sync-with-ec2',
}

export enum GlobalNetworkAction {
  DELETE_ENTITY = 'delete-entity',
}

export enum NetworkTreeAction {
  RENAME = 'rename',
  CREATE_COMPANY_FOLDER = 'create-company-folder',
  CREATE_NETWORK_FOLDER = 'create-network-folder',
  DELETE = 'tree-delete',
}

export enum RightClickExtraActions {
  REPORTS = 'reports',
  GO_TO = 'goTo',
  DELETE = 'delete',
}
